export default `subscription deletedTodo {
  deletedTodo {
	todoId
  }
}`;
